import React, { useEffect, useMemo, useState } from "react";
import userProfilePlaceholder from "assets/images/users/user-profile.png";
import BreadCrumb from "Common/BreadCrumb";
import withRouter from "Common/withRouter";
import AccountNumber from "Common/Components/bankAccount/AccountNumber";

const UserProfile = () => {
  // Meta title
  document.title = "Profile | Betaplay Dashboard";

  const user = useMemo(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : {};
  }, []);

  const [details, setDetails] = useState<Record<string, any>>({});

  useEffect(() => {
    setDetails(user);
  }, [user]);

  return (
    <React.Fragment>
      <div className="container mx-auto p-4">
        <BreadCrumb title="Profile" pageTitle="Profile" />

        {/* Profile Card */}
        <div className="bg-white rounded-lg shadow-md p-6 flex flex-col md:flex-row items-center md:items-start gap-6">
          {/* Profile Image */}
          <div className="flex-shrink-0">
            <img
              src={details.image || userProfilePlaceholder}
              alt="User profile"
              className="w-36 h-36 rounded-full object-cover border border-gray-300"
            />
          </div>

          {/* User Details */}
          <div className="flex-1 text-left">
            <h2 className="text-xl font-semibold text-gray-800">
              {details.username || "Admin"}
            </h2>
            <p className="text-sm text-gray-500">ID: #{details.id || 1}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              <div>
                <p className="text-sm text-gray-600">
                  <strong>Email:</strong> {details.email || "admin@gmail.com"}
                </p>
                <p className="text-sm text-gray-600">
                  <strong>Phone:</strong> {details.phoneNumber || "1234567890"}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600">
                  <strong>Balance:</strong> ₦
                  {details.balance?.toFixed(2) || "0.00"}
                </p>
                <p className="text-sm text-gray-600">
                  <strong>Number of Games:</strong> {details.numberOfGames || 0}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bank Account Section */}
        <div className="mt-6">
          <AccountNumber />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
